// ISBN validation and utilities

export function validateISBN10(isbn: string): boolean {
  const cleaned = isbn.replace(/[-\s]/g, '');
  if (!/^\d{9}[\dX]$/.test(cleaned)) return false;
  
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cleaned[i]) * (10 - i);
  }
  const checkDigit = cleaned[9] === 'X' ? 10 : parseInt(cleaned[9]);
  sum += checkDigit;
  
  return sum % 11 === 0;
}

export function validateISBN13(isbn: string): boolean {
  const cleaned = isbn.replace(/[-\s]/g, '');
  if (!/^\d{13}$/.test(cleaned)) return false;
  
  let sum = 0;
  for (let i = 0; i < 12; i++) {
    sum += parseInt(cleaned[i]) * (i % 2 === 0 ? 1 : 3);
  }
  const checkDigit = (10 - (sum % 10)) % 10;
  
  return checkDigit === parseInt(cleaned[12]);
}

export function validateISBN(isbn: string): { valid: boolean; type: 'isbn10' | 'isbn13' | null } {
  const cleaned = isbn.replace(/[-\s]/g, '');
  
  if (cleaned.length === 10) {
    return { valid: validateISBN10(cleaned), type: 'isbn10' };
  } else if (cleaned.length === 13) {
    return { valid: validateISBN13(cleaned), type: 'isbn13' };
  }
  
  return { valid: false, type: null };
}

export function normalizeISBN(isbn: string): string {
  return isbn.replace(/[-\s]/g, '').toUpperCase();
}

export function isISBNQuery(query: string): boolean {
  const cleaned = normalizeISBN(query);
  return cleaned.length === 10 || cleaned.length === 13;
}